module.exports = __webpack_public_path__ + "static/media/traditional_banneer.9726d7de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/traditional_banneer.jpg
// module id = 1910
// module chunks = 0